import { InjectionToken } from '@angular/core';
import type { EN_TRANSLATION } from './translations/en.translation';

export type Translation = typeof EN_TRANSLATION;

export enum WebsiteLanguage {
  English = 'en',
  Czech = 'cs',
}

export const SUPPORTED_LANGUAGES = [
  WebsiteLanguage.English,
  WebsiteLanguage.Czech,
] as const;

/**
 * Whether a URL segment names one of the site languages. An Express route
 * param (`/:locale/article/...`) is an unvalidated string; anything that goes
 * back into a `Location` header must pass this first.
 */
export function isWebsiteLanguage(value: unknown): value is WebsiteLanguage {
  return (SUPPORTED_LANGUAGES as readonly unknown[]).includes(value);
}

export const TRANSLATION = new InjectionToken<Translation>('TRANSLATION');
